import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconUserSettingsStyle0 = cosmosIconCss;

const CosmosIconUserSettings$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconUserSettings extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'bac483ca3338059c5a5f80f2146a33bb09598250', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '2491084c66f5ac9bd3f7a162521b189446ad2760', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '579281eb9be743374587cb7b776a002f5eff99b5', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M3.5 5h15a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5h-15a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5Zm14 10.5v-9h-13v9h13Zm-9.5-4a.981.981 0 0 1-1.009-.91l-.1-.869A1.033 1.033 0 0 1 8 8.5a1.033 1.033 0 0 1 1.111 1.221l-.1.869A.983.983 0 0 1 8 11.5Zm4.5 0a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5V12a.5.5 0 0 0-.5-.5h-3Zm-.5-2a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-.5Zm-4.95 2.574a1.973 1.973 0 0 0 1.89 0 .337.337 0 0 1 .435.01c.325.278.543.66.617 1.08a.258.258 0 0 1-.283.336H6.291a.258.258 0 0 1-.283-.336 1.8 1.8 0 0 1 .617-1.08c.12-.11.3-.114.425-.01Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconUserSettingsStyle0; }
}, [1, "cosmos-icon-user-settings", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-user-settings"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-user-settings":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconUserSettings$1);
            }
            break;
    } });
}

const CosmosIconUserSettings = CosmosIconUserSettings$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconUserSettings, defineCustomElement };
